import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  customVariables: ['~/scss/variables.scss'],
  treeShake: true,
  breakpoint: {
    thresholds: {
      xs: 576,
      sm: 768,
      md: 992,
      lg: 1200
    }
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#1F2022',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        mcsprimary: '#4F46E5',
        light: '#F8F8F8',
        anchor: '#2196F3',
        background: '#F2F2F2'
      }
    }
  }
});
